import { createAction, createSelector, createSlice } from "@reduxjs/toolkit";


const initialState = {
	apiError: false,
	loading: false,
	IOTSimdetails: {},
	addtoCartResponse:{},
    ProfileEligibilityDetails:{}
};

const bulkUploadSlice = createSlice({
	name: "bulkUpload",
	initialState,
	reducers: {
		resetbulkUploadSlice: (state) => {
			return initialState;
		},
		setIOTSimdetails:(state, action)=>{			
			state["IOTSimdetails"] = action.payload;
		},
        setProfileEligibilityDetails:(state,action)=>
        {
            state["ProfileEligibilityDetails"] = action.payload;
        },
		setUploadFileStatus:(state,action)=>
		{
			state["uploadFileStatus"] = action.payload;
		},
		setAddressCheckStatus:(state,action)=>
		{
			state["addressCheckStatus"] = action.payload;
		},
		setAddressCountResponse:(state,action)=>
		{
			state["AddressCountResponse"] = action.payload;
		},
		setShippingAddress:(state,action)=>
		{
			state["shippingAddress"] = action.payload;
		},		
		setAcccount:(state,action)=>
		{
			state["Account"] = action.payload;
		},
		setPlanDetails:(state,action) => {
            state["PlanDetails"] = action.payload;
		},
		setBIDeviceDetails:(state,action) => {
            state["BIDeviceDetails"] = action.payload;
		},
		setEcpdMbaSuppression:(state,action) => {
            state["EcpdMbaSuppression"] = action.payload;
		},	
		setBillingAddress:(state,action) => {
            state["billingAddress"] = action.payload;
		},	
		setCompleteOrderResp:(state,action) => {
            state["CompleteOrderResp"] = action.payload;
		},
		setBulkSelectedPlanId:(state,action)=>
		{
			state["selectedBulkPlanId"] = action.payload;
		},
		setBulkSelectedPlan:(state,action)=>
		{
			state["bulkSelectedPlan"] = action.payload;
		},
		setBulkContractTerm:(state,action)=>
		{
			state["bulkContractTerm"] = action.payload;
		},
		setFileId:(state,action)=>
		{
		    state["FileId"] = action.payload;
		},
		setSelectedAccount:(state,action)=>
		{
			state["selectedAccount"] = action.payload;
		},
		setBulkUploadEmail:(state,action)=>
		{
			state["BulkUploadEmail"] = action.payload;
		},
		setSelectedDevice:(state,action)=>
		{
				state["selectedDevice"] = action.payload;
		},
		setBulkInternetAmtResp:(state,action)=>
		{
			state["bulkInternetAmount"] = action.payload;
		},
		setAPIError: (state, action) => {
			state["apiError"] = action.payload;
		},
		setPageLoading: (state, action) => {
			state["loading"] = action.payload;
		},
		setAddtoCartResponse:(state,action) => {
            state["addtoCartResponse"] = action.payload;
		},
		setErrorResponse:(state,action) => {
            state["errorResponse"] = action.payload;
		},
		setNotification: (state, action) => {
			state["notification"] = action.payload;
		  },
	    setErrorInfo: (state, action) => {
		    state["errorInfo"] = action.payload;
	     },		
	},
});
//export const accessToShowMarketplace = createAction("BussProductSlice/accessToShowMarketplace");
export const reducer = bulkUploadSlice.reducer;

// export const addToCart = createAction("BussProductSlice/addToCart");
// export const marketplaceAddToCart = createAction("BussProductSlice/marketplaceAddToCart");
// export const bussGridwall = createAction("BussProductSlice/bussGridwall");
// export const getIOTSimdetails = createAction("bulkUploadSlice/getIOTSimdetails");
// export const addIOTSimdetails = createAction("bulkUploadSlice/addIOTSimdetails");
export const getProfileEligibilityDetails = createAction("bulkUploadSlice/getProfileEligibilityDetails");
export const uploadFileForOrder = createAction("bulkUploadSlice/uploadFileForOrder");
export const processAddressCheckBulk = createAction("bulkUploadSlice/processAddressCheckBulk");
export const getBulkAddressCount = createAction("bulkUploadSlice/getBulkAddressCount");
export const retrieveAccounts = createAction("bulkUploadSlice/retrieveAccounts");
export const getBIPlanBundlesBulk = createAction("bulkUploadSlice/getBIPlanBundlesBulk");
export const retrieveBIService = createAction("bulkUploadSlice/retrieveBIService");
export const ecpdAndMbaSuppression = createAction("bulkUploadSlice/getBillingAddress");
export const getBillingAddress = createAction("bulkUploadSlice/ecpdAndMbaSuppression");
export const getSavedShippingAddress = createAction("bulkUploadSlice/getSavedShippingAddress");
export const getBulkInternetAmount = createAction("bulkUploadSlice/getBulkInternetAmount");
export const SubmitOrder = createAction("bulkUploadSlice/SubmitOrder");
export const retrieveBulkFileStatus = createAction("bulkInternet/retrieveBulkFileStatus");
export const uploadFileForActivateRouters = createAction("bulkUploadSlice/uploadFileForActivateRouters");

export const {
    resetbulkUploadSlice,
	setAcccount,
	setPlanDetails,
	setBIDeviceDetails,
	setEcpdMbaSuppression,
	setBillingAddress,
	setShippingAddress,
	setCompleteOrderResp,
	setAPIError,
	setPageLoading,
	setIOTSimdetails,
	setAddtoCartResponse,
    setProfileEligibilityDetails,
	setUploadFileStatus,
	setAddressCheckStatus,
	setBulkSelectedPlanId,
	setBulkSelectedPlan,
	setSelectedAccount,
	setBulkUploadEmail,
	setSelectedDevice,
	setFileId,
    setBulkInternetAmtResp,
	setAddressCountResponse,
	setErrorResponse,
	setErrorInfo,
	setNotification,
	setBulkContractTerm
} = bulkUploadSlice.actions;
